module.exports = __webpack_public_path__ + "img/product-preview-12.dff506c.png";